import { Layout as LayoutAnt, theme, Spin } from "antd";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import PageNotFound from "../Pages/Errors/PageNotFound";
import Reports from "../Pages/Reports";
import Dashboard from "../Pages/Dashboard";
import Sales from "../Pages/Sales";
import Contracts from "../Pages/Contracts";
import Plans from "../Pages/Management/Plans";
import Customers from "../Pages/Management/Customers";
import Services from "../Pages/Management/Services";
import Categories from "../Pages/Expenses/Categories";
import Expenses from "../Pages/Expenses/Expenses";
import Users from "../Pages/Admin/Users";
import Profiles from "../Pages/Admin/Profiles";
import AccountsPage from "../Pages/Admin/Account";
import { authorizedAccess } from "../services/utils";
import { useQuery } from "react-query";
import { getAccountDetails, isAccountComplete } from "../services/accounts.service";
const { Content } = LayoutAnt;

export default function ContentCustom({
  content,
  modulePermissions = [],
}: any) {
  const {
    token: { colorBgLayout },
  } = theme.useToken();

  const verifyAuthorizedAccess = (permissions: string[]) =>
    authorizedAccess(modulePermissions, permissions);

  const location = useLocation();

  const {
    data: accountResponse,
    isLoading: loadingAccount,
    isError: errorAccount,
  } = useQuery(["getAccountDetails"], () => getAccountDetails(), {
    refetchOnWindowFocus: false,
  });

  const account = accountResponse?.data || accountResponse;
  const accountComplete = account ? isAccountComplete(account) : false;

  const isOnAccountPage = location.pathname === "/admin/account";
  const mustCompleteAccount = !accountComplete && !errorAccount;

  if (loadingAccount) {
    return (
      <Content
        style={{
          background: colorBgLayout,
          minHeight: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin />
      </Content>
    );
  }

  if (mustCompleteAccount && verifyAuthorizedAccess([
    "accounts-accounts:read",
    "accounts-accounts:write",
  ]) && !isOnAccountPage) {
    return (
      <Content style={{ background: colorBgLayout }}>
        <Routes>
          <Route path="/admin/account" element={<AccountsPage />} />
          <Route path="*" element={<Navigate to="/admin/account" replace />} />
        </Routes>
      </Content>
    );
  }

  return (
    <Content style={{ background: colorBgLayout }}>
      <Routes>
        {verifyAuthorizedAccess([
          "dashboard-dashboard:read",
          "dashboard-dashboard:write",
        ]) && (
          <>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </>
        )}

        {verifyAuthorizedAccess([
          "reports-reports:read",
          "reports-reports:write",
        ]) && (
            <Route path="/reports" element={<Reports />} />
        )}

        {verifyAuthorizedAccess(["sales-sales:read", "sales-sales:write"]) && (
          <>
            <Route path="/sales" element={<Sales action="list" />} />
          </>
        )}

        {verifyAuthorizedAccess(["sales-sales:write"]) && (
          <>
            <Route path="/sales/create" element={<Sales action="create" />} />
            <Route path="/sales/:uuid/edit" element={<Sales action="edit" />} />
            <Route
              path="/sales/:uuid/duplicate"
              element={<Sales action="duplicate" />}
            />
          </>
        )}

        {verifyAuthorizedAccess([
          "contracts-contracts:read",
          "contracts-contracts:write",
        ]) && (
          <>
            <Route path="/contracts" element={<Contracts action="list" />} />
          </>
        )}

        {verifyAuthorizedAccess(["contracts-contracts:write"]) && (
          <>
            <Route
              path="/contracts/create"
              element={<Contracts action="create" />}
            />
            <Route
              path="/contracts/:uuid/edit"
              element={<Contracts action="edit" />}
            />
            <Route
              path="/contracts/:uuid/duplicate"
              element={<Contracts action="duplicate" />}
            />
          </>
        )}

        {verifyAuthorizedAccess(["plans-plans:read", "plans-plans:write"]) && (
          <>
            <Route path="/management/plans" element={<Plans action="list" />} />
          </>
        )}

        {verifyAuthorizedAccess(["plans-plans:write"]) && (
          <>
            <Route
              path="/management/plans/create"
              element={<Plans action="create" />}
            />
            <Route
              path="/management/plans/:uuid/edit"
              element={<Plans action="edit" />}
            />
            <Route
              path="/management/plans/:uuid/duplicate"
              element={<Plans action="duplicate" />}
            />
          </>
        )}

        {verifyAuthorizedAccess([
          "customers-customers:read",
          "customers-customers:write",
        ]) && (
          <>
            <Route
              path="/management/customers"
              element={<Customers action="list" />}
            />
          </>
        )}

        {verifyAuthorizedAccess(["customers-customers:write"]) && (
          <>
            <Route
              path="/management/customers/create"
              element={<Customers action="create" />}
            />
            <Route
              path="/management/customers/:id/edit"
              element={<Customers action="edit" />}
            />
          </>
        )}

        {verifyAuthorizedAccess([
          "services-services:read",
          "services-services:write",
        ]) && (
          <>
            <Route path="/management/services" element={<Services />} />
          </>
        )}

        {verifyAuthorizedAccess([
          "expenses-categories:read",
          "expenses-categories:write",
        ]) && (
          <>
            <Route path="/expenses/categories" element={<Categories />} />
          </>
        )}

        {verifyAuthorizedAccess([
          "expenses-expenses:read",
          "expenses-expenses:write",
        ]) && (
          <>
            <Route path="/expenses/expenses" element={<Expenses />} />
          </>
        )}

        {verifyAuthorizedAccess([
          "accounts-accounts:read",
          "accounts-accounts:write",
        ]) && (
          <>
            <Route path="/admin/account" element={<AccountsPage />} />
          </>
        )}

        {verifyAuthorizedAccess(["users-users:read", "users-users:write"]) && (
          <>
            <Route path="/admin/users" element={<Users action="list" />} />
          </>
        )}

        {verifyAuthorizedAccess(["users-users:write"]) && (
          <>
            <Route
              path="/admin/users/create"
              element={<Users action="create" />}
            />
            <Route
              path="/admin/users/:id/edit"
              element={<Users action="edit" />}
            />
          </>
        )}

        {verifyAuthorizedAccess([
          "users-profiles:read",
          "users-profiles:write",
        ]) && (
          <>
            <Route
              path="/admin/profiles"
              element={<Profiles action="list" />}
            />
          </>
        )}

        {verifyAuthorizedAccess(["users-profiles:write"]) && (
          <>
            <Route
              path="/admin/profiles/create"
              element={<Profiles action="create" />}
            />
            <Route
              path="/admin/profiles/:id/edit"
              element={<Profiles action="edit" />}
            />
          </>
        )}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Content>
  );
}
